import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenStore } from '../tokens/token.store';

/**
 * Attaches the Bearer access token and enables the refresh cookie on
 * every outbound request.
 *
 * - `withCredentials: true` is required so the httpOnly refresh cookie
 *   travels with the call (works cross-origin when the backend sets
 *   `Access-Control-Allow-Credentials: true`).
 * - Never reads or stores the refresh token on the client.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokens = inject(TokenStore);
  const token = tokens.accessToken();

  const authed = req.clone({
    withCredentials: true,
    setHeaders: token ? { Authorization: `Bearer ${token}` } : {},
  });

  return next(authed);
};
